import { Injectable, NgZone } from '@angular/core';
import { Router } from '@angular/router';

@Injectable({
  providedIn: 'root'
})
export class NavigationService {

  constructor(
    private router: Router,
    private ngZone: NgZone,
  ) { }

  // Callers often run inside Firebase SDK promise callbacks that resolve outside Angular's zone;
  // navigating there changes the URL but the view is not re-rendered until the next interaction.
  goHome(isClientUser = false) {
    if (isClientUser) {
      const returnUrl = sessionStorage.getItem('clientReturnUrl');
      sessionStorage.removeItem('clientReturnUrl');
      return this.ngZone.run(() => this.router.navigateByUrl(returnUrl || '/client-portal'));
    }
    return this.ngZone.run(() => this.router.navigateByUrl('/project/calendar'));
  }

  goLogin() {
    return this.ngZone.run(() => this.router.navigateByUrl('/auth/login'));
  }

}
